import { useMutation, useQuery, useQueryClient } from "react-query";
import qs from "qs-lite";
import api from "../../utils/api";
import { invalidate } from "../../helpers/clientHelper";
import { useHubSnackBar } from "../useSnackBar";

const MOLDS = "/molds";

const getSearchMoldList = ({ queryKey }) => {
  const search = queryKey[1];
  const query = qs.stringify(search);
  const path = `${MOLDS}/search/part?${query}`;
  return api.get(path);
};
export const useGetSearchMoldList = ({ search, locationId, partId = null }) => {
  const query = {
    ...(search && { search }),
    ...(partId && { partId }),
    locationId,
  };
  return useQuery([MOLDS, query, "search"], getSearchMoldList, {
    enabled: !!locationId,
  });
};

const getPartMoldData = ({ queryKey }) => {
  const search = queryKey[1];
  const query = qs.stringify(search);
  const path = `${MOLDS}/part?${query}`;
  return api.get(path);
};
export const useGetPartMoldData = ({ locationId, partId }) => {
  return useQuery([MOLDS, { locationId, partId }, "details"], getPartMoldData, {
    enabled: !!locationId,
  });
};

const postCreateMold = (payload) => api.post(MOLDS, payload);
export const usePostCreateMold = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(postCreateMold, {
    onSuccess: () => {
      invalidate(queryClient, MOLDS);
      addSnackbarSuccess({ message: "Successfully Created Mold" });
    },
  });
};
